import type { ReactNode } from 'react';
import { ProgressSteps, StepAside, StepBar } from '@/components/ui/ProgressSteps';

/**
 * The Forge as a progression (08/10/2026): 1 Fiche → 2 Test → 3 App. Each step
 * holds its own action (validate the sheet, test, create the tool), instead of
 * three buttons side by side whose order and blockers were not visible.
 */
export type ForgeStep = 'sheet' | 'test' | 'app';
export type ForgePane = ForgeStep | 'settings';

const STEPS = [
  { key: 'sheet', label: 'Fiche' },
  { key: 'test', label: 'Test' },
  { key: 'app', label: 'App' },
] as const;

interface StepsProps {
  active: ForgePane;
  /** The first step not done: where the work is. */
  current: ForgeStep;
  done: Record<ForgeStep, boolean>;
  onSelect: (pane: ForgePane) => void;
}

export const ForgeSteps = ({ active, current, done, onSelect }: StepsProps) => (
  <div className="mt-4">
    <ProgressSteps<ForgeStep, 'settings'>
      label="Étapes de l’outil"
      steps={STEPS}
      active={active}
      current={current}
      done={done}
      onSelect={onSelect}
      aside={<StepAside active={active === 'settings'} onClick={() => onSelect('settings')}>Définition et sources</StepAside>}
    />
  </div>
);

/** The head of a Forge step: where it stands, in one sentence, and its action. */
export const ForgeStepBar = (props: { text: string; tone?: 'neutral' | 'done' | 'warning' | 'error'; children?: ReactNode }) => (
  <StepBar {...props} className="mx-auto max-w-7xl" />
);
